import api, { openApi } from './api';

/** Estado do 2FA do usuário logado. */
export const getTwoFactorStatus = async () => {
  const { data } = await api.get('/2fa/status');
  return data; // { enabled, activatedAt, recoveryCodesRemaining }
};

/**
 * Gera um segredo pendente e devolve o QR. O 2FA ainda NÃO fica ligado — só
 * depois de `activateTwoFactor` com um código válido.
 */
export const startTwoFactorSetup = async () => {
  const { data } = await api.post('/2fa/setup');
  return data; // { secret, otpauthUrl }
};

/**
 * Conclui a ativação. Devolve os códigos de recuperação (única vez que eles
 * existem em claro) e um par de tokens novo — ligar o 2FA incrementa o
 * `tokenVersion` no backend, então gravar esses tokens é obrigatório, senão a
 * própria aba cai no refresh seguinte.
 */
export const activateTwoFactor = async (code) => {
  const { data } = await api.post('/2fa/activate', { code });
  return data; // { recoveryCodes, token, refreshToken }
};

/** Desligar exige senha atual E código — ver DisableTwoFactorService. */
export const disableTwoFactor = async ({ password, code }) => {
  const { data } = await api.post('/2fa/disable', { password, code });
  return data; // { token, refreshToken }
};

export const regenerateRecoveryCodes = async (code) => {
  const { data } = await api.post('/2fa/recovery-codes', { code });
  return data.recoveryCodes;
};

/**
 * Etapa 2 do login. Usa `openApi` porque o usuário ainda não tem access token:
 * quem autentica esta chamada é o `challengeToken` da etapa 1, no header.
 */
export const verifyTwoFactorChallenge = async ({ challengeToken, code }) => {
  const { data } = await openApi.post(
    '/auth/2fa/verify',
    { code },
    { headers: { Authorization: `Bearer ${challengeToken}` } }
  );
  return data; // { token, refreshToken, expiresIn }
};

/**
 * Enrollment obrigatório (a política da empresa exige 2FA e o usuário ainda não
 * configurou). Mesmo desafio da etapa 1, mas com estágio `enroll` — o backend
 * não aceita um desafio de verificação nestas rotas.
 */
export const startEnrollWithChallenge = async (challengeToken) => {
  const { data } = await openApi.post(
    '/auth/2fa/enroll/start',
    {},
    { headers: { Authorization: `Bearer ${challengeToken}` } }
  );
  return data; // { secret, otpauthUrl }
};

/** Confirma o primeiro código e, só aí, abre a sessão. */
export const confirmEnrollWithChallenge = async ({ challengeToken, code }) => {
  const { data } = await openApi.post(
    '/auth/2fa/enroll/confirm',
    { code },
    { headers: { Authorization: `Bearer ${challengeToken}` } }
  );
  return data; // { recoveryCodes, token, refreshToken, expiresIn }
};

/**
 * Destrave administrativo: desliga o 2FA de outro usuário que perdeu o app e os
 * códigos de recuperação. Encerra as sessões abertas dele junto.
 */
export const resetUserTwoFactor = async (userId) => {
  const { data } = await api.post(`/users/${userId}/2fa/reset`);
  return data; // { userId, email }
};

/** Política de exigência da empresa: optional | required_admins | required_all. */
export const getTwoFactorPolicy = async () => {
  const { data } = await api.get('/2fa/policy');
  return data.policy;
};

/**
 * Endurecer a política derruba a sessão de quem passa a ser obrigado — o
 * retorno diz quantos. Rota própria, e não `PUT /companySettings`, justamente
 * por causa desse efeito colateral.
 */
export const updateTwoFactorPolicy = async (policy) => {
  const { data } = await api.put('/2fa/policy', { policy });
  return data; // { policy, affectedUsers }
};
